import React, { ChangeEvent, memo, useCallback, useEffect, useRef, useState } from 'react'
import { AlertMessageInputProps } from './alertMessageInput.typings'
import { selectIndicators } from '../../../selectors/chart'
import { getUserAlertMessage } from '../../../util/alerts'
import { useSelector } from 'react-redux'
import { TextField } from '@mui/material'

const AlertMessageInput: React.FC<AlertMessageInputProps> = ({
                                                                 condition,
                                                                 symbolDisplayName,
                                                                 message,
                                                                 onChange,
                                                                 className,
                                                                 edit
                                                             }) => {
    const indicators = useSelector(selectIndicators)
    const manualInput = useRef(false)
    const [isAutoUpdatable, setIsAutoUpdatable] = useState(false)
    const initialRender = useRef(true)

    useEffect(() => {
        const generatedMessage = getUserAlertMessage(condition, symbolDisplayName, indicators)

        if (edit && initialRender.current) {
            if (message === generatedMessage) {
                setIsAutoUpdatable(true)
            } else {
                setIsAutoUpdatable(false)
            }
            initialRender.current = false
        }
    }, [edit, message, condition, symbolDisplayName, indicators])

    useEffect(() => {
        const generatedMessage = getUserAlertMessage(condition, symbolDisplayName, indicators)
        if (!manualInput.current) {
            if (edit && isAutoUpdatable) {
                onChange(generatedMessage)
            } else if (!edit && message !== generatedMessage) {
                onChange(generatedMessage)
            }
        }
    }, [condition, indicators, symbolDisplayName, message, onChange, edit, isAutoUpdatable])

    const onInputChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        manualInput.current = true
        setIsAutoUpdatable(false)
        onChange(event.target.value)
    }, [onChange])

    return (
        <TextField
            fullWidth
            multiline
            size="small"
            minRows={2}
            value={message}
            className={className}
            onChange={onInputChange}
        />
    )
}

export default memo(AlertMessageInput)
